import { makeStyles } from '@mui/styles'
import React from 'react'

interface Props {
  src: string
}

const useStyles = makeStyles({
  image: ({ src }: Props) => ({
    backgroundImage: `url(${src})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    minHeight: 265,
    flex: '40%',
  }),
})

const BookingDetailsImage: React.FC<React.PropsWithChildren<Props>> = ({ src }) => {
  const classes = useStyles({ src })

  return <div className={classes.image} />
}

export default BookingDetailsImage
